import React from 'react'
import { Button, ButtonGroup ,Stack} from '@chakra-ui/react'
import { Link } from '@chakra-ui/react'

import { ExternalLinkIcon } from '@chakra-ui/icons'
import { FaGithub,} from "react-icons/fa"
import styles from './project.module.css';
const Project = (props) => {
  return (
    <div id='project_section'>
        
      <h1 className={styles.project}>Projects</h1> 
      <div className={styles.container}>
          <img className={styles.img} src='https://i.imgur.com/LkHhOGC.png'/>
          <div>
              <h2 className={styles.projectHeading}>Timecamp.com clone</h2>
              <p className={styles.description}>TimeCamp is a simple time tracking app to help you gain insights into your projects and tasks</p>
              <br/>
              <p className={styles.description}>A collaborative project, built in 5 days by a team of 5 developers </p>
              <br/>
              <p className={styles.description}>ReactJS | Redux | Chakra UI | Styled-Components | NodeJS | ExpressJS | Mongoose | MongoDB | Jsonwebtoken | bcryptJS  </p>
              <Stack direction='row' spacing={4} mt={8}>
                    <Button leftIcon={<FaGithub />} colorScheme='teal' variant='solid' >
                        <Link  href='https://github.com/pandeyratnesh1997/Unit-6-TimeCamp.com' isExternal>
                            View source 
                        </Link>
                    </Button>
                    <Button  colorScheme='teal' variant='outline'>
                    <Link  href='https://timecampclone.netlify.app/' isExternal>
                            Live 
                    </Link>
                    </Button>
              </Stack>
          </div>
          
        </div> 

     


        <div className={styles.container}>
          <img className={styles.img} src='https://i.imgur.com/rlIoYIm.png'/>
          <div>
              <h2 className={styles.projectHeading}>Zara.com clone</h2>
              <p className={styles.description}>ZARA is a Spanish multi-national retail clothing chain. It specialises in fast fashion, and sells clothing, accessories, shoes, beauty products and perfumes.</p>
              <br/>
              <p className={styles.description}>A collaborative project, built in 5 days by a team of 6 developers </p>
              <br/>
              <p className={styles.description}>HTML5 | CSS3 | ReactJs | Redux | Chakra UI </p>
              <Stack direction='row' spacing={4} mt={8}>
                    <Button leftIcon={<FaGithub />} colorScheme='teal' variant='solid' >
                        <Link  href='https://github.com/pandeyratnesh1997/Unit-5-ZARA.COM' isExternal>
                            View source 
                        </Link>
                    </Button>
                    <Button  colorScheme='teal' variant='outline'>
                    <Link  href='https://jazzy-ganache-1db991.netlify.app/' isExternal>
                            Live 
                        </Link>
                    </Button>
              </Stack>
          </div>
          
        </div> 


        <div className={styles.container}>
          <img className={styles.img} src='https://user-images.githubusercontent.com/100183222/161419353-80e8c085-2c7f-414a-bf9b-551f74a25a28.png'/>
          <div>
              <h2 className={styles.projectHeading}>Dunzo.com clone</h2>
              <p className={styles.description}>Dunzo is an Indian company that delivers groceries and essentials, fruits and vegetables, meat, pet supplies, food, and medicines in major cities.</p>
              <br/>
              <p className={styles.description}>A collaborative project, built in 5 days by a team of 6 developers </p>
              <br/>
              <p className={styles.description}>HTML5 | CSS3 | JavaScript </p>
              <Stack direction='row' spacing={4} mt={8}>
                    <Button leftIcon={<FaGithub />} colorScheme='teal' variant='solid' >
                        <Link  href='https://github.com/pandeyratnesh1997/Dunzo' isExternal>
                            View source 
                        </Link>
                    </Button>
                    <Button  colorScheme='teal' variant='outline'>
                    <Link  href='https://stirring-mandazi-87d93f.netlify.app/' isExternal>
                            Live 
                        </Link>
                    </Button>
              </Stack>
          </div>
          
        </div> 
        
    </div>
  )
}

export default Project